module.exports = __webpack_public_path__ + "img/rolling.80e0f8de.gif";